let baseWebsiteUrl = process.env.VUE_APP_URL_WEBSITE

export default {
  internal: {
    notfound: {
      meta: {
        title: 'Error',
        icon: 'home',
        public: true
      },
      path: '/404',
      alias: '*',
      component: () => import('../views/Error'),
      props: () => ({
        status: 404
      })
    },
    home: {
      meta: {
        title: 'Start',
        icon: 'agila:home',
        public: true
      },
      path: '/home',
      alias: '/',
      component: () => import('../views/Home'),
      props: route => ({
        register: typeof route.query.register !== 'undefined'
      })
    },
    contracts: {
      meta: {
        title: 'Verträge',
        icon: 'agila:contracts'
      },
      path: '/contracts',
      component: () => import('../views/Contracts'),
      props: route => ({
        animal: parseInt(route.query.animal)
      })
    },
    contractDetails: {
      meta: {
        title: 'Vertragsdetails',
        icon: 'agila:contract'
      },
      path: '/contracts/details',
      component: () => import('../views/ContractDetails'),
      props: route => ({
        animal: parseInt(route.query.animal),
        risk: parseInt(route.query.risk)
      })
    },
    contractTransfer: {
      meta: {
        title: 'Vertragsumschreibung',
        icon: 'agila:contract'
      },
      path: '/contracts/transfer',
      component: () => import('../views/ContractTransfer'),
      props: route => ({
        animal: parseInt(route.query.animal),
        risk: parseInt(route.query.risk)
      })
    },
    history: {
      meta: {
        title: 'Leistungshistorie',
        icon: 'agila:submitInvoice'
      },
      path: '/contracts/history',
      component: () => import('../views/History'),
      props: route => ({
        animal: parseInt(route.query.animal),
        policy: parseInt(route.query.policy)
      })
    },
    activities: {
      meta: {
        title: 'Aktivitäten',
        icon: 'agila:activities'
      },
      path: '/activities',
      component: () => import('../views/Activities'),
    },
    submitInvoice: {
      meta: {
        title: 'Rechnung einreichen',
        icon: 'agila:submitInvoice'
      },
      path: '/submit-invoice',
      component: () => import('../views/SubmitInvoice'),
      props: route => ({
        animal: parseInt(route.query.animal),
        risk: parseInt(route.query.risk)
      })
    },
    submitClaim: {
      meta: {
        title: 'Schaden melden',
        icon: 'agila:submitClaim'
      },
      path: '/submit-claim',
      component: () => import('../views/SubmitClaim'),
      props: route => ({
        animal: parseInt(route.query.animal),
        risk: parseInt(route.query.risk)
      })
    },
    faq: {
      meta: {
        title: 'FAQ',
        icon: 'agila:faq',
        public: true
      },
      path: '/faq',
      component: () => import('../views/Faq'),
    },
    contact: {
      meta: {
        title: 'Kontakt',
        icon: 'agila:contact',
        public: true
      },
      path: '/contact',
      component: () => import('../views/Contact'),
    },
    about: {
      meta: {
        title: 'Über diese App',
        icon: 'agila:info',
        public: true
      },
      path: '/about',
      component: () => import('../views/About'),
    },
    dev: {
      meta: {
        title: 'Entwicklung',
        icon: 'agila:paw',
        public: true
      },
      path: '/dev',
      component: () => import('../views/Dev'),
    },
    /*
    providerInfo: {
      meta: {
        title: 'Impressum',
        icon: 'agila:imprint',
        public: true
      },
      path: '/provider-info',
      component: () => import('../views/ProviderInfo'),
    },
    */
    activation: {
      meta: {
        title: 'Kontoaktivierung',
        public: true
      },
      path: '/activation/:number/:token',
      component: () => import('../views/Activation'),
    },
    login: {
      meta: {
        title: 'Anmeldung',
        public: true,
        redirectLoggedIn: 'home'
      },
      path: '/login',
      component: () => import('../views/Login'),
      props: route => ({
        presetEmail: route.query.presetEmail,
        presetPassword: route.query.presetPassword,
        showHelp: route.query.help,
        unauthorized: route.query.unauthorized
      })
    },
    loginWithPartner: {
      meta: {
        title: 'Anmeldung mit Vertragsnummer',
        public: true,
        redirectLoggedIn: 'home'
      },
      path: '/login-with-partner',
      component: () => import('../views/LoginWithPartner'),
      props: route => ({
        redirect: route.query.redirect
      })
    },
    quickInvoice: {
      meta: {
        title: 'Rechnung einreichen',
        public: true,
        redirectLoggedIn: 'submitInvoice'
      },
      path: '/quick-invoice',
      component: () => import('../views/LoginWithPartner'),
      props: () => ({
        embedded: true
      })
    },
    forgotPassword: {
      meta: {
        title: 'Passwort vergessen',
        public: true,
        redirectLoggedIn: 'home'
      },
      path: '/login/forgotpassword',
      component: () => import('../views/ForgotPassword'),
    },
    newPassword: {
      meta: {
        title: 'Neues Passwort',
        public: true,
        redirectLoggedIn: 'accountPassword'
      },
      path: '/login/newpassword/:number/:token',
      component: () => import('../views/Account/Password'),
    },
    accountEmailAddress: {
      meta: {
        title: 'E-Mail-Adresse ändern'
      },
      path: '/account/email-address',
      component: () => import('../views/Account/EmailAddress')
    },
    accountEmailAddressConfirmation: {
      meta: {
        title: 'E-Mail-Adresse ändern',
        public: true
      },
      path: '/account/email-address/:token',
      component: () => import('../views/Account/EmailAddress'),
    },
    account: {
      meta: {
        title: 'Ihre Daten',
        icon: 'agila:customerInfo'
      },
      path: '/account',
      component: () => import('../views/Account/Index'),
    },
    accountPassword: {
      meta: {
        title: 'Ihr Passwort ändern'
      },
      path: '/account/password',
      component: () => import('../views/Account/Password'),
    },
    accountEdit: {
      meta: {
        title: 'Ihre Daten ändern'
      },
      path: '/account/edit',
      component: () => import('../views/Account/Edit'),
    },
    accountPayment: {
      meta: {
        title: 'Ihre Bankdaten ändern'
      },
      path: '/account/payment',
      component: () => import('../views/Account/Payment'),
    },
    /*
    termsAndConditions: {
      meta: {
        title: 'Nutzungsbedingungen',
        icon: 'agila:contract',
        public: true
      },
      path: '/terms-and-conditions',
      component: () => import('../views/TermsAndConditions'),
    },
    dataProtection: {
      meta: {
        title: 'Datenschutz',
        icon: 'agila:contract',
        public: true
      },
      path: '/data-protection',
      component: () => import('../views/DataProtection'),
    },
    */
    consent: {
      meta: {
        title: 'Cookie Einstellungen',
        icon: 'cookie',
        public: true
      },
      path: '/consent',
      component: () => import('../views/Consent'),
    },
    pfotendoctor: {
      meta: {
        title: 'Pfotendoctor',
        icon: 'remoteVet'
      },
      path: '/pfotendoctor',
      component: () => import('../views/Pfotendoctor'),
    },
    pfotendoctorNew: {
      meta: {
        title: 'Videosprechstunde',
        icon: 'pfotenDoctor',
        set: 'svg',
      },
      path: '/pfotendoctor',
      component: () => import('../views/Pfotendoctor'),
    },
  },
  external: {
    website: {
      meta: {
        title: 'AGILA Webseite',
        icon: 'agila:logoCircle'
      },
      url: baseWebsiteUrl
    },
    referral: {
      meta: {
        title: 'Weiterempfehlung',
        icon: 'agila:customerInfo'
      },
      url: baseWebsiteUrl + '/empfehlen?utm_source=app&utm_medium=textlink&utm_campaign=weiterempfehlung-kwk'
    },
    websiteImprint: {
      meta: {
        title: 'Impressum',
        icon: 'agila:imprint'
      },
      url: baseWebsiteUrl + '/impressum'
    },
    websiteDataProtection: {
      meta: {
        title: 'Datenschutz',
        icon: 'agila:contract'
      },
      url: baseWebsiteUrl + '/datenschutz'
    },
    websiteComplaintManagement: {
      meta: {
        title: 'Beschwerdemanagement',
        icon: 'agila:contract'
      },
      url: baseWebsiteUrl + '/kontakt/beschwerdemanagement'
    },
    websiteDisclaimer: {
      meta: {
        title: 'Disclaimer',
        icon: 'agila:contract'
      },
      url: baseWebsiteUrl + '/disclaimer'
    },
    websiteContact: {
      meta: {
        title: 'Kontakt',
        icon: 'agila:contact'
      },
      url: 'https://kontakt.agila.de',
      // modal: true,
    },
    facebook: {
      meta: {
        title: 'Facebook',
        icon: 'fab:facebook'
      },
      url: 'https://de-de.facebook.com/AGILA.Welt'
    },
    instagram: {
      meta: {
        title: 'Instagram',
        icon: 'fab:instagram'
      },
      url: 'https://www.instagram.com/agila.de/'
    }
  }
}